














































































import { Component, Vue, Mixins } from "vue-property-decorator";
// 混入
import Loading from "@/mixins/loading";
import TablePagination from "@/mixins/tablePagination";
// 接口
import { demandList, deleteDemand } from "@/api/system";

@Component
export default class ProductFeedback extends Mixins(Loading, TablePagination) {
  private tableData = [];
  dialogVisible = false;
  dialogImageUrl = "";
  total = 20;

  mounted() {
    this.getData();
  }

  /**
   * methods
   */
  getData() {
    this.showLoading();
    demandList({
      pageSize: this.pageSize,
      pageNum: this.currentPage,
    }).then((res: any) => {
      this.tableData = res.data.list;
      this.total = res.data.total;
      this.hideLoading();
    });
  }

  handleClick(row: any) {
    this.$message.success("修改成功");
  }

  handleDelete(row: { id: number }) {
    this.$confirm(`是否该需求`, "提示", {
      confirmButtonText: "确定",
      cancelButtonText: "取消",
      type: "warning",
    }).then(() => {
      deleteDemand({
        id: row.id,
      }).then((res) => {
        this.$message.success("删除成功");
        this.getData();
      });
    });
  }

  previewAvater(url: string) {
    this.dialogImageUrl = url;
    this.dialogVisible = true;
  }
}
